/* =========================================================================
   COMPONENT: ATELIER QUANTITY WIDGET (Self-Aware Capacity Logic)
   ========================================================================= */
window.AtelierQtyWidget = (function() {

  function init() {
    // 1. Listen for clicks universally across all widgets (Cards & Modal)
    document.addEventListener('click', function(e) {
      
      // -- ADD / PLUS --
      var addBtn = e.target.closest('.js-qty-add') || e.target.closest('.js-qty-plus');
      if (addBtn) {
        e.preventDefault();
        e.stopPropagation();
        handleCapacityCheck(addBtn);
        return;
      }

      // -- MINUS --
      var minusBtn = e.target.closest('.js-qty-minus');
      if (minusBtn) {
        e.preventDefault();
        e.stopPropagation();
        var variantId = getVariantId(minusBtn);
        if (window.AtelierBuilder && variantId) window.AtelierBuilder.minus(variantId);
        return;
      }

      // -- REMOVE --
      var removeBtn = e.target.closest('.js-qty-remove');
      if (removeBtn) {
        e.preventDefault();
        e.stopPropagation();
        var variantId = getVariantId(removeBtn);
        if (window.AtelierBuilder && variantId) window.AtelierBuilder.remove(variantId);
        return;
      }
    });

    // 2. Inline Action Click Handlers (Inside the Modal)
    document.addEventListener('click', function(e) {
      // Handle Box Upgrades
      if (e.target.classList.contains('js-qty-trigger-upgrade')) {
        e.preventDefault();
        e.stopPropagation(); // Prevent bubbling
        
        // Find the variant ID associated with this specific error message
        var widget = e.target.closest('.atelier-qty-widget');
        var variantId = getVariantId(widget);
        
        executeBoxUpgrade(variantId);
      }
      
      // Handle Box Checkouts
      if (e.target.classList.contains('js-qty-trigger-checkout')) {
        e.preventDefault();
        e.stopPropagation();
        if (window.AtelierBuilder) {
          // Pass the main desktop CTA button to show the loading state nicely
          var mainAddBtn = document.querySelector('.atelier-desktop-cta .atelier-add-btn') || e.target;
          var mainErrorEl = document.getElementById('AtelierError');
          window.AtelierBuilder.submit(mainAddBtn, mainErrorEl);
        }
      }
    });

    // 3. UI Sync: Listen for global state changes and update ALL widgets on the page
    document.addEventListener('AtelierBuilder:QtyChanged', syncAllWidgets);
  }

  // --- CAPACITY & ERROR LOGIC ---

  function handleCapacityCheck(btn) {
    var state = window.AtelierBuilderState;
    var widget = btn.closest('.atelier-qty-widget');
    var variantId = getVariantId(btn);
    
    if (!state || !variantId || !widget) return;

    if (state.totalSelected >= state.targetQty) {
      triggerErrorUI(btn, widget, state.targetQty, variantId);
    } else {
      if (window.AtelierBuilder) window.AtelierBuilder.add(variantId);
    }
  }

  function triggerErrorUI(btn, widget, currentSize, variantId) {
    var isModal = !!btn.closest('#AtelierModal');
    var errorEl = widget.querySelector('.js-qty-error');

    // Always execute the physical shake on the clicked button
    btn.classList.add('atelier-shake-error');
    setTimeout(function() { btn.classList.remove('atelier-shake-error'); }, 400);

    if (isModal) {
      if (currentSize < 24) {
        errorEl.innerHTML = '<a href="#" class="js-qty-trigger-upgrade" style="text-decoration:underline;">Upgrade your box</a> to add more.';
        errorEl.style.display = 'block';
      } else {
        errorEl.innerHTML = 'Your box is full. <a href="#" class="js-qty-trigger-checkout" style="text-decoration:underline;">Proceed to checkout</a>.';
        errorEl.style.display = 'block';
      }
    } else {
      if (currentSize < 24) {
        var nextSize = getNextBoxSize(currentSize);
        if (nextSize && window.AtelierDialog) {
          window.AtelierDialog.open({
            title: 'Upgrade your box?',
            text: 'Your box is full. Would you like to upgrade to the ' + nextSize.qty + '-piece box to fit this chocolate?',
            confirmText: 'Upgrade Box',
            cancelText: 'Cancel'
          }).then(function(confirmed) {
            if (confirmed) {
              nextSize.btn.click();
              if (window.AtelierBuilder) window.AtelierBuilder.add(variantId);
            }
          });
        }
      } else {
        // Box 24 text swap. Save original text to dataset so we can restore it safely!
        if (btn.classList.contains('js-qty-add') && !btn.classList.contains('is-full')) {
          btn.dataset.originalText = btn.textContent;
          btn.textContent = 'Box full';
          btn.classList.add('is-full');
          
          setTimeout(function() {
            // Only revert if it hasn't been cleared by a Minus click already
            if (btn.classList.contains('is-full')) {
              btn.textContent = btn.dataset.originalText || 'Add';
              btn.classList.remove('is-full');
            }
          }, 2500);
        }
      }
    }
  }

  // --- HELPERS & SYNCING ---

  function getVariantId(el) {
    if (el.closest('#AtelierModal') && window.AtelierModalUI) {
      return window.AtelierModalUI.getCurrentVariant();
    }
    var card = el.closest('.atelier-card');
    return card ? card.dataset.variantId : null;
  }

  function clearWidgetError(widget) {
    if (!widget) return;
    
    var errorEl = widget.querySelector('.js-qty-error');
    if (errorEl) {
      errorEl.style.display = 'none';
      errorEl.innerHTML = '';
    }
    
    var addBtn = widget.querySelector('.js-qty-add');
    if (addBtn) {
      addBtn.classList.remove('atelier-shake-error', 'is-full');
      if (addBtn.dataset.originalText && addBtn.textContent === 'Box full') {
        addBtn.textContent = addBtn.dataset.originalText;
      }
    }
    
    var counter = widget.querySelector('.js-qty-counter');
    if (counter) counter.classList.remove('atelier-shake-error');
  }

  function clearAllErrors() {
    // Sweep the entire page and clear errors from all widgets
    document.querySelectorAll('.atelier-qty-widget').forEach(function(widget) {
      clearWidgetError(widget);
    });
    // Also clear the master modal error state just in case
    if (window.AtelierModalUI) window.AtelierModalUI.clearError();
  }

  function getNextBoxSize(currentSize) {
    var sizesContainer = document.querySelector('.atelier-sizes');
    if (!sizesContainer) return null;
    var availableSizes = Array.from(sizesContainer.querySelectorAll('.atelier-size-btn')).map(function(b) {
      return { qty: parseInt(b.dataset.quantity) || 12, btn: b };
    }).sort(function(a, b) { return a.qty - b.qty; });
    return availableSizes.find(function(s) { return s.qty > currentSize; });
  }

  function executeBoxUpgrade(variantId) {
    var state = window.AtelierBuilderState;
    var nextSize = getNextBoxSize(state.targetQty);
    
    if (nextSize) {
      // 1. Upgrade the box size instantly
      nextSize.btn.click(); 
      
      // 2. Automatically drop the chocolate into their newly upgraded box
      // (Note: This automatically triggers 'syncAllWidgets', which clears all errors globally)
      if (variantId && window.AtelierBuilder) {
        window.AtelierBuilder.add(variantId);
      }
      
      // 3. Inject a success message back into the modal so the user knows what happened
      var modalWidget = document.querySelector('#AtelierModal .atelier-qty-widget');
      if (modalWidget) {
        var errorEl = modalWidget.querySelector('.js-qty-error');
        if (errorEl) {
          // Use inline color to override the default red error text so it looks like a success note
          errorEl.innerHTML = 'Box upgraded to ' + nextSize.qty + ' pieces.';
          errorEl.style.display = 'block';

          // Fade the message out after a few seconds so it doesn't linger forever
          setTimeout(function() {
            if (errorEl.innerHTML.indexOf('Box upgraded') !== -1) {
              errorEl.style.display = 'none';
              errorEl.innerHTML = '';
            }
          }, 4000);
        }
      }
    }
  }

  function syncAllWidgets() {
    var state = window.AtelierBuilderState;
    if (!state || !state.selection) return;

    // CRITICAL UX FIX: If the box is no longer full (e.g. they minused an item), instantly clear ALL error states globally!
    if (state.totalSelected < state.targetQty) {
      clearAllErrors();
    }

    document.querySelectorAll('.atelier-qty-widget').forEach(function(widget) {
      var variantId = getVariantId(widget);
      if (!variantId) return;

      var qty = state.selection[variantId] || 0;
      var wrap = widget.closest('.atelier-card-wrap');
      if (wrap) wrap.classList.toggle('is-selected', qty > 0);

      var addBtn = widget.querySelector('.js-qty-add');
      var counter = widget.querySelector('.js-qty-counter');
      var disp = widget.querySelector('.js-qty-disp');
      var minusBtn = widget.querySelector('.js-qty-minus');

      if (qty > 0) {
        if (addBtn) addBtn.style.display = 'none';
        if (counter) counter.style.display = 'flex';
        if (disp) disp.textContent = qty;
        if (minusBtn) minusBtn.disabled = false;
      } else {
        if (addBtn) addBtn.style.display = '';
        if (counter) counter.style.display = 'none';
        if (disp) disp.textContent = '0';
      }
    });
  }

  return { init, syncAllWidgets };
})();

if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', window.AtelierQtyWidget.init); } 
else { window.AtelierQtyWidget.init(); }